import { Map, List } from 'immutable';
import { resolveResource } from './resolve';
import createSelector from './createSelector';
import resourceSelector from './resourceSelector';
import resourceIncludeSelector from './resourceIncludeSelector';
import cacheSelector from './cacheSelector';

const firstpageResourceSelector = (state) => resourceSelector(state, { type:'pages', id:'frontpage' });
const firstoageIncludeSelector = (state) => resourceIncludeSelector(state, { type:'pages', id:'frontpage' });
const firstpageSelector = createSelector(
	[cacheSelector, firstpageResourceSelector, firstoageIncludeSelector],
	(cache, resource, include) => {
		const model = resolveResource(resource, cache, include);
		
		const editorialsTeasers	= model.getIn(['editorials','teasers'], List());
		const newsTeasers				= model.getIn(['news','teasers'], List());
		const urgentHero				= model.getIn(['urgent_news','top_teasers'], List());
		const urgentTeaser			= model.getIn(['urgent_news','teasers'], List());
		const urgentNews				= model.getIn(['urgent_news'], Map());
		
		const hero = editorialsTeasers.slice(0, 1);
		const topEditorials = editorialsTeasers.slice(1, 9);
		const editorials = editorialsTeasers.slice(9, 13);
		const otherEditorials = editorialsTeasers.slice(13, 21);
		
		const topNews = newsTeasers.slice(0, 1);
		const news = newsTeasers.slice(0, 7);

		const urgentBanner = Map().withMutations((map) => {
			
			var value = urgentNews.getIn(['bannerLink']);
			if(value) { map.set('targetUrl', value); }

			value = urgentNews.getIn(['bannerScope']);
			if(value) { map.set('scope', value); }

			value = urgentNews.getIn(['bannerTitle']);
			if(value) { map.set('title', value); }

			value = urgentNews.getIn(['topImagePlacement']);
			if(value) { map.set('imagePlacement', value); }

		});

		const urgent = Map().withMutations((map) => {
			map.set('destination', urgentNews);
			map.set('hero', urgentHero);
			map.set('teasers', urgentTeaser);
			map.set('banner', urgentBanner);
		});

	return Map().withMutations((map) => {
			return map
				.set('urgent', urgent)
				.set('hero', hero)
				.set('topEditorials', topEditorials)
				.set('editorials', editorials)
				.set('otherEditorials', otherEditorials)
				.set('topNews', topNews)
				.set('news', news);
		});
	}
);

export default firstpageSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/firstpageSelector.js
 **/